<div class="text-center" id="presentation">
    <div class="ui container about-container">
        <h2>Nos services de voyages</h2>
        <div class="ui stackable four column grid margin-top-50">
            <div class="column">
                <div class="ui card full-width">
                    <div class="image">
                        <img class="trip-image" src="../../../../../assets/img/scolaire.jpg">
                    </div>
                    <div class="content">
                        <p class="header">Transport scolaire</p>
                    </div>
                </div>
            </div>

            <div class="column">
                <div class="ui card full-width">
                    <div class="image">
                        <img class="trip-image" src="../../../../../assets/img/rgtr.jpg">
                    </div>
                    <div class="content">
                        <p class="header">Ligne RGTR</p>
                    </div>
                </div>
            </div>

            <div class="column">
                <div class="ui card full-width">
                    <div class="image">
                        <img class="trip-image" src="../../../../../assets/img/excursion.jpg">
                    </div>
                    <div class="content">
                        <p class="header">Excursion</p>
                    </div>
                </div>
            </div>

            <div class="column">
                <div class="ui card full-width">
                    <div class="image">
                        <img class="trip-image" src="../../../../../assets/img/bus.jpg">
                    </div>
                    <div class="content">
                        <p class="header">Voyage en bus</p>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="separator text-center">

    </div>

    <div class="services-container text-center">
        <h2>Notre responsable Schiltz Voyage</h2>
        <employee [employee]="employee"></employee>
    </div>
</div>



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/trips/presentation/presentation.html